
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire1126"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire1126"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("6TaBW", function(module, exports) {

$parcel$export(module.exports, "countryCodes", () => $50401c43f41e65e3$export$7bc41e2d36612b98);
const $50401c43f41e65e3$export$7bc41e2d36612b98 = [
    {
        name: "Afghanistan",
        code: "+93"
    },
    {
        name: "Albania",
        code: "+355"
    },
    {
        name: "Algeria",
        code: "+213"
    },
    {
        name: "Andorra",
        code: "+376"
    },
    {
        name: "Angola",
        code: "+244"
    },
    {
        name: "Argentina",
        code: "+54"
    },
    {
        name: "Armenia",
        code: "+374"
    },
    {
        name: "Australia",
        code: "+61"
    },
    {
        name: "Austria",
        code: "+43"
    },
    {
        name: "Azerbaijan",
        code: "+994"
    },
    {
        name: "Bahamas",
        code: "+1-242"
    },
    {
        name: "Bahrain",
        code: "+973"
    },
    {
        name: "Bangladesh",
        code: "+880"
    },
    {
        name: "Barbados",
        code: "+1-246"
    },
    {
        name: "Belarus",
        code: "+375"
    },
    {
        name: "Belgium",
        code: "+32"
    },
    {
        name: "Belize",
        code: "+501"
    },
    {
        name: "Benin",
        code: "+229"
    },
    {
        name: "Bhutan",
        code: "+975"
    },
    {
        name: "Bolivia",
        code: "+591"
    },
    {
        name: "Bosnia and Herzegovina",
        code: "+387"
    },
    {
        name: "Botswana",
        code: "+267"
    },
    {
        name: "Brazil",
        code: "+55"
    },
    {
        name: "Brunei",
        code: "+673"
    },
    {
        name: "Bulgaria",
        code: "+359"
    },
    {
        name: "Burkina Faso",
        code: "+226"
    },
    {
        name: "Burundi",
        code: "+257"
    },
    {
        name: "Cambodia",
        code: "+855"
    },
    {
        name: "Cameroon",
        code: "+237"
    },
    {
        name: "Canada",
        code: "+1"
    },
    {
        name: "Cape Verde",
        code: "+238"
    },
    {
        name: "Central African Republic",
        code: "+236"
    },
    {
        name: "Chad",
        code: "+235"
    },
    {
        name: "Chile",
        code: "+56"
    },
    {
        name: "China",
        code: "+86"
    },
    {
        name: "Colombia",
        code: "+57"
    },
    {
        name: "Comoros",
        code: "+269"
    },
    {
        name: "Congo (Congo-Brazzaville)",
        code: "+242"
    },
    {
        name: "Costa Rica",
        code: "+506"
    },
    {
        name: "Croatia",
        code: "+385"
    },
    {
        name: "Cuba",
        code: "+53"
    },
    {
        name: "Cyprus",
        code: "+357"
    },
    {
        name: "Czech Republic",
        code: "+420"
    },
    {
        name: "Denmark",
        code: "+45"
    },
    {
        name: "Djibouti",
        code: "+253"
    },
    {
        name: "Dominica",
        code: "+1-767"
    },
    {
        name: "Dominican Republic",
        code: "+1-809"
    },
    {
        name: "Ecuador",
        code: "+593"
    },
    {
        name: "Egypt",
        code: "+20"
    },
    {
        name: "El Salvador",
        code: "+503"
    },
    {
        name: "Equatorial Guinea",
        code: "+240"
    },
    {
        name: "Eritrea",
        code: "+291"
    },
    {
        name: "Estonia",
        code: "+372"
    },
    {
        name: "Eswatini",
        code: "+268"
    },
    {
        name: "Ethiopia",
        code: "+251"
    },
    {
        name: "Fiji",
        code: "+679"
    },
    {
        name: "Finland",
        code: "+358"
    },
    {
        name: "France",
        code: "+33"
    },
    {
        name: "Gabon",
        code: "+241"
    },
    {
        name: "Gambia",
        code: "+220"
    },
    {
        name: "Georgia",
        code: "+995"
    },
    {
        name: "Germany",
        code: "+49"
    },
    {
        name: "Ghana",
        code: "+233"
    },
    {
        name: "Greece",
        code: "+30"
    },
    {
        name: "Grenada",
        code: "+1-473"
    },
    {
        name: "Guatemala",
        code: "+502"
    },
    {
        name: "Guinea",
        code: "+224"
    },
    {
        name: "Guinea-Bissau",
        code: "+245"
    },
    {
        name: "Guyana",
        code: "+592"
    },
    {
        name: "Haiti",
        code: "+509"
    },
    {
        name: "Honduras",
        code: "+504"
    },
    {
        name: "Hungary",
        code: "+36"
    },
    {
        name: "Iceland",
        code: "+354"
    },
    {
        name: "India",
        code: "+91"
    },
    {
        name: "Indonesia",
        code: "+62"
    },
    {
        name: "Iran",
        code: "+98"
    },
    {
        name: "Iraq",
        code: "+964"
    },
    {
        name: "Ireland",
        code: "+353"
    },
    {
        name: "Israel",
        code: "+972"
    },
    {
        name: "Italy",
        code: "+39"
    },
    {
        name: "Jamaica",
        code: "+1-876"
    },
    {
        name: "Japan",
        code: "+81"
    },
    {
        name: "Jordan",
        code: "+962"
    },
    {
        name: "Kazakhstan",
        code: "+7"
    },
    {
        name: "Kenya",
        code: "+254"
    },
    {
        name: "Kiribati",
        code: "+686"
    },
    {
        name: "Kuwait",
        code: "+965"
    },
    {
        name: "Kyrgyzstan",
        code: "+996"
    },
    {
        name: "Laos",
        code: "+856"
    },
    {
        name: "Latvia",
        code: "+371"
    },
    {
        name: "Lebanon",
        code: "+961"
    },
    {
        name: "Lesotho",
        code: "+266"
    },
    {
        name: "Liberia",
        code: "+231"
    },
    {
        name: "Libya",
        code: "+218"
    },
    {
        name: "Liechtenstein",
        code: "+423"
    },
    {
        name: "Lithuania",
        code: "+370"
    },
    {
        name: "Luxembourg",
        code: "+352"
    },
    {
        name: "Madagascar",
        code: "+261"
    },
    {
        name: "Malawi",
        code: "+265"
    },
    {
        name: "Malaysia",
        code: "+60"
    },
    {
        name: "Maldives",
        code: "+960"
    },
    {
        name: "Mali",
        code: "+223"
    },
    {
        name: "Malta",
        code: "+356"
    },
    {
        name: "Mauritania",
        code: "+222"
    },
    {
        name: "Mauritius",
        code: "+230"
    },
    {
        name: "Mexico",
        code: "+52"
    },
    {
        name: "Moldova",
        code: "+373"
    },
    {
        name: "Monaco",
        code: "+377"
    },
    {
        name: "Mongolia",
        code: "+976"
    },
    {
        name: "Montenegro",
        code: "+382"
    },
    {
        name: "Morocco",
        code: "+212"
    },
    {
        name: "Mozambique",
        code: "+258"
    },
    {
        name: "Myanmar",
        code: "+95"
    },
    {
        name: "Namibia",
        code: "+264"
    },
    {
        name: "Nepal",
        code: "+977"
    },
    {
        name: "Netherlands",
        code: "+31"
    },
    {
        name: "New Zealand",
        code: "+64"
    },
    {
        name: "Nicaragua",
        code: "+505"
    },
    {
        name: "Niger",
        code: "+227"
    },
    {
        name: "Nigeria",
        code: "+234"
    },
    {
        name: "North Korea",
        code: "+850"
    },
    {
        name: "North Macedonia",
        code: "+389"
    },
    {
        name: "Norway",
        code: "+47"
    },
    {
        name: "Oman",
        code: "+968"
    },
    {
        name: "Pakistan",
        code: "+92"
    },
    {
        name: "Palau",
        code: "+680"
    },
    {
        name: "Panama",
        code: "+507"
    },
    {
        name: "Papua New Guinea",
        code: "+675"
    },
    {
        name: "Paraguay",
        code: "+595"
    },
    {
        name: "Peru",
        code: "+51"
    },
    {
        name: "Philippines",
        code: "+63"
    },
    {
        name: "Poland",
        code: "+48"
    },
    {
        name: "Portugal",
        code: "+351"
    },
    {
        name: "Qatar",
        code: "+974"
    },
    {
        name: "Romania",
        code: "+40"
    },
    {
        name: "Russia",
        code: "+7"
    },
    {
        name: "Rwanda",
        code: "+250"
    },
    {
        name: "Saint Kitts and Nevis",
        code: "+1-869"
    },
    {
        name: "Saint Lucia",
        code: "+1-758"
    },
    {
        name: "Saint Vincent and the Grenadines",
        code: "+1-784"
    },
    {
        name: "Samoa",
        code: "+685"
    },
    {
        name: "San Marino",
        code: "+378"
    },
    {
        name: "Saudi Arabia",
        code: "+966"
    },
    {
        name: "Senegal",
        code: "+221"
    },
    {
        name: "Serbia",
        code: "+381"
    },
    {
        name: "Seychelles",
        code: "+248"
    },
    {
        name: "Sierra Leone",
        code: "+232"
    },
    {
        name: "Singapore",
        code: "+65"
    },
    {
        name: "Slovakia",
        code: "+421"
    },
    {
        name: "Slovenia",
        code: "+386"
    },
    {
        name: "Solomon Islands",
        code: "+677"
    },
    {
        name: "Somalia",
        code: "+252"
    },
    {
        name: "South Africa",
        code: "+27"
    },
    {
        name: "South Korea",
        code: "+82"
    },
    {
        name: "South Sudan",
        code: "+211"
    },
    {
        name: "Spain",
        code: "+34"
    },
    {
        name: "Sri Lanka",
        code: "+94"
    },
    {
        name: "Sudan",
        code: "+249"
    },
    {
        name: "Suriname",
        code: "+597"
    },
    {
        name: "Sweden",
        code: "+46"
    },
    {
        name: "Switzerland",
        code: "+41"
    },
    {
        name: "Syria",
        code: "+963"
    },
    {
        name: "Taiwan",
        code: "+886"
    },
    {
        name: "Tajikistan",
        code: "+992"
    },
    {
        name: "Tanzania",
        code: "+255"
    },
    {
        name: "Thailand",
        code: "+66"
    },
    {
        name: "Togo",
        code: "+228"
    },
    {
        name: "Tonga",
        code: "+676"
    },
    {
        name: "Trinidad and Tobago",
        code: "+1-868"
    },
    {
        name: "Tunisia",
        code: "+216"
    },
    {
        name: "Turkey",
        code: "+90"
    },
    {
        name: "Turkmenistan",
        code: "+993"
    },
    {
        name: "Uganda",
        code: "+256"
    },
    {
        name: "Ukraine",
        code: "+380"
    },
    {
        name: "United Arab Emirates",
        code: "+971"
    },
    {
        name: "United Kingdom",
        code: "+44"
    },
    {
        name: "United States",
        code: "+1"
    },
    {
        name: "Uruguay",
        code: "+598"
    },
    {
        name: "Uzbekistan",
        code: "+998"
    },
    {
        name: "Vanuatu",
        code: "+678"
    },
    {
        name: "Vatican City",
        code: "+379"
    },
    {
        name: "Venezuela",
        code: "+58"
    },
    {
        name: "Vietnam",
        code: "+84"
    },
    {
        name: "Yemen",
        code: "+967"
    },
    {
        name: "Zambia",
        code: "+260"
    },
    {
        name: "Zimbabwe",
        code: "+263"
    }
];

});


var $6TaBW = parcelRequire("6TaBW");

var $cP3LP = parcelRequire("cP3LP");
document.addEventListener("DOMContentLoaded", ()=>{
    let signupDataGlobal; // Declare the variable here
    const signupForm = document.getElementById("signup-form");
    const otpForm = document.getElementById("otp-form");
    const countryCodeDropdownOptions = document.querySelector("#country-code-dropdown .dropdown-options");
    const selectedCountryCodeSpan = document.getElementById("selected-country-code");
    const hiddenCountryCodeInput = document.getElementById("country-code");
    // Populate country codes dropdown
    if (countryCodeDropdownOptions && typeof (0, $6TaBW.countryCodes) !== "undefined") {
        (0, $6TaBW.countryCodes).forEach((country)=>{
            const a = document.createElement("a");
            a.href = "#";
            a.setAttribute("data-value", country.code);
            a.textContent = `${country.code} (${country.name})`;
            countryCodeDropdownOptions.appendChild(a);
        });
        // Set initial selected value (e.g., India +91)
        const defaultCountry = (0, $6TaBW.countryCodes).find((country)=>country.code === "+91");
        if (defaultCountry) {
            selectedCountryCodeSpan.textContent = `${defaultCountry.code} (${defaultCountry.name})`;
            hiddenCountryCodeInput.value = defaultCountry.code;
        }
    }
    const phoneInput = document.getElementById("phone");
    const phoneNumberError = document.getElementById("phone-number-error");
    function validatePhoneNumber() {
        const currentPhone = phoneInput.value.trim();
        phoneNumberError.textContent = ""; // Clear previous errors
        const phoneRegex = /^\d*$/; // Only allow digits
        if (!phoneRegex.test(currentPhone)) {
            phoneNumberError.textContent = "Phone number must contain only digits.";
            phoneInput.setCustomValidity("Phone number must contain only digits.");
        } else phoneInput.setCustomValidity("");
    }
    // Add event listeners
    if (phoneInput) phoneInput.addEventListener("input", validatePhoneNumber);
    const countryCodeDropdown = document.getElementById("country-code-dropdown");
    if (countryCodeDropdown) countryCodeDropdown.addEventListener("click", (event)=>{
        if (event.target.tagName === "A") // A country code was selected, re-validate phone number
        validatePhoneNumber();
    });
    const OrganizationInput = document.getElementById("organization");
    const OrganizationList = document.getElementById("organization-list");
    let existingOrganizations = [];
    // Function to populate Organization suggestions
    async function populateOrganizationsuggestions() {
        try {
            const response = await fetch("/api/institutions/names");
            if (response.ok) {
                existingOrganizations = await response.json();
                OrganizationList.innerHTML = "";
                existingOrganizations.forEach((inst)=>{
                    const option = document.createElement("option");
                    option.value = inst.name;
                    OrganizationList.appendChild(option);
                });
            }
        } catch  {
        // Failed to fetch organizations
        }
    }
    // Auto-fill address details when existing Organization is selected
    if (OrganizationInput) OrganizationInput.addEventListener("input", async (e)=>{
        const selectedName = e.target.value.trim();
        // Clear auto-filled data if name is too short or cleared
        if (!selectedName || selectedName.length < 2) {
            clearAndUnlockFields();
            return;
        }
        // Case-insensitive match from the fetched existing organizations
        const match = existingOrganizations.find((inst)=>inst.name.toLowerCase() === selectedName.toLowerCase());
        if (match) {
            const typeEl = document.getElementById("workplace-type");
            if (typeEl) typeEl.value = match.workplace_type || "School";
            unlockFields();
            (0, $cP3LP.showToast)(`Institution "${match.name}" recognized. Please complete all required organization details.`, "info");
        } else unlockFields();
    });
    function clearAndUnlockFields() {
        const fields = [
            "address",
            "city",
            "workplace-type",
            "country",
            "state"
        ];
        fields.forEach((id)=>{
            const el = document.getElementById(id);
            if (el) el.value = "";
        });
        unlockFields();
    }
    function unlockFields() {
        const fields = [
            "address",
            "city",
            "workplace-type",
            "country",
            "state"
        ];
        fields.forEach((id)=>{
            const el = document.getElementById(id);
            if (el) {
                el.readOnly = false;
                // Check for custom dropdown wrapper
                const dropdown = el.closest(".custom-dropdown") || document.querySelector(`.custom-dropdown[data-input="${id}"]`);
                if (dropdown) {
                    dropdown.style.pointerEvents = "auto";
                    dropdown.style.opacity = "1";
                    dropdown.style.filter = "none";
                }
                el.style.backgroundColor = "";
                el.style.cursor = "default";
            }
        });
    }
    // Initial population
    populateOrganizationsuggestions();
    // Function to populate country dropdown
    async function populateCountriesDropdown() {
        try {
            const response = await fetch("countries_list.json");
            const countries = await response.json();
            const countryOptions = document.getElementById("country-options");
            if (!countryOptions) return;
            countryOptions.innerHTML = "";
            countries.forEach((countryName)=>{
                const a = document.createElement("a");
                a.href = "#";
                a.setAttribute("data-value", countryName);
                a.textContent = countryName;
                countryOptions.appendChild(a);
            });
            // Set default country
            const countryInput = document.getElementById("country");
            const countryDisplay = document.getElementById("selected-country");
            if (countryInput && countries.includes("India")) {
                countryInput.value = "India";
                if (countryDisplay) countryDisplay.textContent = "India";
                populateStatesDropdown("India");
            }
        } catch  {
            (0, $cP3LP.showToast)("Failed to load country list.", "error");
        }
    }
    // Function to populate state dropdown based on selected country
    async function populateStatesDropdown(selectedCountryName) {
        const stateOptions = document.getElementById("state-options");
        if (!stateOptions) return;
        stateOptions.innerHTML = "";
        if (!selectedCountryName) return;
        try {
            const response = await fetch(`/api/countries/${encodeURIComponent(selectedCountryName)}/states`);
            if (response.ok) {
                const states = await response.json();
                states.forEach((stateName)=>{
                    const a = document.createElement("a");
                    a.href = "#";
                    a.setAttribute("data-value", stateName);
                    a.textContent = stateName;
                    stateOptions.appendChild(a);
                });
            }
        } catch  {
            (0, $cP3LP.showToast)("Network error loading states.", "error");
        }
    }
    // Event listener for country dropdown change (using custom event from common.js)
    const countryDropdownEl = document.getElementById("country-dropdown");
    if (countryDropdownEl) countryDropdownEl.addEventListener("dropdown-change", (e)=>{
        populateStatesDropdown(e.detail.value);
        // Reset state display
        const stateInput = document.getElementById("state");
        const stateDisplay = document.getElementById("selected-state");
        if (stateInput) stateInput.value = "";
        if (stateDisplay) stateDisplay.textContent = "Select State";
    });
    // Initial population of countries dropdown
    populateCountriesDropdown();
    if (signupForm) signupForm.addEventListener("submit", async function(event) {
        event.preventDefault();
        // Run phone number validation before submitting
        validatePhoneNumber();
        if (phoneInput.checkValidity() === false) {
            (0, $cP3LP.showToast)(phoneNumberError.textContent, "error");
            return;
        }
        const username = document.getElementById("username").value;
        const email = document.getElementById("email").value;
        const countryCode = document.getElementById("country-code").value;
        const phone = document.getElementById("phone").value;
        const fullPhone = countryCode + phone;
        const password = document.getElementById("password").value;
        const confirmPassword = document.getElementById("confirm-password").value;
        const workplaceType = document.getElementById("workplace-type").value;
        const Organization = document.getElementById("organization").value;
        const address = document.getElementById("address").value;
        const city = document.getElementById("city").value;
        const state = document.getElementById("state").value;
        const country = document.getElementById("country").value;
        if (password !== confirmPassword) {
            (0, $cP3LP.showToast)("Passwords do not match!", "error");
            return;
        }
        (0, $cP3LP.showGlobalPreloader)("Sending OTP...");
        signupDataGlobal = {
            username: username,
            email: email,
            phone: fullPhone,
            phone_country_code: countryCode,
            password: password,
            institution_name: Organization,
            workplace_type: workplaceType,
            role: "admin",
            address: address,
            city: city,
            state: state,
            country: country
        };
        try {
            // Request OTP for signup
            const response = await fetch("/api/auth/request_signup_otp", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify(signupDataGlobal)
            });
            if (response.ok) {
                const data = await response.json();
                document.getElementById("global-preloader-message").textContent = "OTP Sent Successfully!";
                setTimeout(()=>{
                    (0, $cP3LP.showToast)(data.message || "OTP sent to your email and phone via sms or voice. Please verify.", "success");
                    signupForm.style.display = "none"; // Hide signup form
                    otpForm.style.display = "block"; // Show OTP form
                }, 1000);
            } else {
                const data = await response.json();
                const errorMessage = data.error || "Failed to send OTP.";
                (0, $cP3LP.showToast)(errorMessage, "error");
            }
        } catch (error) {
            (0, $cP3LP.showToast)("Network error requesting OTP: " + error, "error");
        } finally{
            (0, $cP3LP.hideGlobalPreloader)();
        }
    });
    if (otpForm) otpForm.addEventListener("submit", async function(event) {
        event.preventDefault();
        const submitButton = otpForm.querySelector('button[type="submit"]');
        if (submitButton) {
            submitButton.disabled = true; // Disable button
            submitButton.textContent = 'Verifying...';
        }
        const emailOtpCode = document.getElementById("email-otp-input").value; // New
        const phoneOtpCode = document.getElementById("phone-otp-input").value; // New
        (0, $cP3LP.showGlobalPreloader)("Verifying OTPs..."); // Updated text
        try {
            // Verify OTPs
            const response = await fetch("/api/auth/verify_signup_otp", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({
                    email: signupDataGlobal.email,
                    email_otp_code: emailOtpCode,
                    phone_otp_code: phoneOtpCode
                })
            });
            const data = await response.json();
            if (response.ok) {
                (0, $cP3LP.showToast)("OTPs verified. Registration request sent. Please wait for the chairman to approve your request. Keep checking email... (Please also check your spam folder.)", "success");
                otpForm.style.display = "none"; // Hide OTP form
            // Optionally, redirect or show a success message
            } else {
                const errorMessage = data.error || "OTP verification failed.";
                (0, $cP3LP.showToast)(errorMessage, "error");
                if (submitButton) submitButton.disabled = false; // Re-enable button on failure
            }
        } catch (error) {
            (0, $cP3LP.showToast)("Network error verifying OTPs: " + error, "error"); // Updated text
            if (submitButton) submitButton.disabled = false; // Re-enable button on error
        } finally{
            (0, $cP3LP.hideGlobalPreloader)();
        }
    });
});


//# sourceMappingURL=signup.ccc00764.js.map
